<template>
  <InstitucionalPageTemplate :loading="loading" v-bind="item" />
</template>

<script>
import InstitucionalPageTemplate from "../components/templates/InstitucionalPageTemplate.vue";

const _config = {
  mod: "about",
};

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => {
          const gallery = [];

          if (data.img && data.img.list)
            data.img.list.map(({ path }) => {
              if (path != data.img.featured.path)
                gallery.push(this.files + path);
            });

          data.img =
            data.img.featured && data.img.featured.path
              ? data.img.featured && data.img.featured.path
              : "";

          data.gallery = gallery;
          state.item = data;
        },
      })
      .then(() => (this.loading = false));
  },
  components: {
    InstitucionalPageTemplate,
  },
};
</script>
